
import {mapGetters} from "vuex";
import seoTags from "@/mixins/seoTags";
import validateCategory from "~/mixins/validateCategory";
export default {
	mixins: [seoTags,validateCategory],
	// validate(ctx) {
	// 	if(ctx.params.category != 'cars'){
	// 		return false
	// 	}
	// 	return true
	// 	// if(Number(ctx.params.car)) {
    //     //  return true
    //     // }else{
    //     //  return false
    //     // }
	// },
	mounted() {
		setTimeout(function () {window.scrollTo(0, -100);}, 1);
	},

	computed: {
		...mapGetters({
			componentCatalog: 'filters/filters/componentCatalog',
		}),
		currentComponent() {
			if (Number(this.$route.params.car)) {
       			 return 'car';
     		 }else {
        		return "catalog-used";
     	 	 }
			// return this.componentCatalog === 'car' ? 'car' : 'catalog-used'
		},
	}
}
